"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(promise, isCanceled) {
  return new Promise(function (resolve, reject) {
    promise.then(function (result) {
      return isCanceled() ? reject() : resolve(result);
    });
  });
};